import {
    earliestAustralianDate,
    earliestNewZealandDate,
    useMediaValueContext
} from '~/services/mediaValue/mediaValueContext';
import {subtract, now} from 'stringdate';
import {useCountry} from '~/feature/country/CountryContext';
import {AU} from 'bigdatr-style';
import {COMPLIANCE_EARLIEST_SELECTABLE_DATE} from './complianceEarliestSelectableDate';

export type DatePickerRangeType = 'spend' | 'creative' | 'compliance';

export default function useDatePickerMinAndMaxDates(
    props:
        | {
              type: 'spend';
              includeForecasted?: boolean;
          }
        | {type: 'creative' | 'compliance'}
) {
    const meta = useMediaValueContext({enabled: props.type === 'spend'});
    const {country} = useCountry();

    if (props.type === 'compliance') {
        return {
            minValue: COMPLIANCE_EARLIEST_SELECTABLE_DATE,
            maxValue: now()
        };
    }

    if (props.type === 'creative') {
        if (country === AU) {
            return {
                minValue: earliestAustralianDate,
                maxValue: now()
            };
        }
        return {
            minValue: earliestNewZealandDate,
            maxValue: now()
        };
    }

    if (props.type === 'spend') {
        let maxValue = subtract('P1M')(meta.forecastCutoff);
        if (props.includeForecasted || country !== AU) {
            maxValue = meta.endDate;
        }

        return {minValue: meta.startDate, maxValue};
    }

    throw new Error(`Unsupported date picker type: ${props.type}`);
}
